import React from 'react';
import { Link } from 'react-router-dom';
import { cx, focusRing } from '../ds/classes';
import { LogoMark } from '../site/Logo';
import { AccountMenu } from '../site/AccountMenu';
import { VerifyBanner } from '../site/VerifyBanner';

/**
 * The mark, back to Projects home. On Projects home it carries the "Studio" name (`withName`);
 * inside a project the mark alone leaves room for where you are.
 */
export const StudioMark = ({ withName = false }) => (
  <Link
    to="/projects"
    aria-label={withName ? undefined : 'Studio home: all projects'}
    className={cx('flex-none inline-flex items-center gap-space-3 min-h-target-min min-w-target-min justify-center rounded-radius-md text-ink no-underline', withName && 'px-space-2', focusRing)}
  >
    <LogoMark className="w-8 h-8" />
    {withName && <span className="font-display text-[18px] leading-[1.25] font-bold">Studio</span>}
  </Link>
);

/** A hairline between the mark and where you are */
export const StudioDivider = () => <span aria-hidden="true" className="flex-none w-px h-6 mx-space-2 bg-line" />;

/** Credits left today; below laptop width only the number shows, and screen readers still hear the words */
const Credits = ({ remaining }) => (
  <span className="flex-none inline-flex items-baseline gap-1.5 px-space-2 text-small text-ink-soft">
    <span className="font-mono text-data text-amber">{remaining}</span>
    <span className="sr-only lg:not-sr-only">{remaining === 1 ? 'analysis' : 'analyses'} left today</span>
  </span>
);

/**
 * The studio's one bar, edge to edge on chrome: the mark and where you are (`children`), any actions
 * for what you're looking at (`actions`, such as a clip's Edit and Upload), then the credits left
 * today and the account menu. It takes the place of the site nav everywhere in the studio.
 */
export const StudioBar = ({ creditsRemaining = null, actions, children }) => (
  <header className="flex-none bg-chrome border-b border-raised text-ink font-text">
    <div className="px-space-2 sm:px-space-4 py-1.5 flex items-center justify-between gap-space-2 sm:gap-space-4">
      <div className="min-w-0 flex items-center gap-space-1">{children}</div>
      <div className="flex-none flex items-center gap-space-2">
        {actions}
        {creditsRemaining !== null && <Credits remaining={creditsRemaining} />}
        <AccountMenu inStudio />
      </div>
    </div>
    <VerifyBanner />
  </header>
);
